import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9 2.25098C9.31066 2.25098 9.5625 2.50282 9.5625 2.81348V9.33074L11.5554 7.33833C11.7751 7.11869 12.1313 7.11874 12.3509 7.33843C12.5706 7.55813 12.5705 7.91429 12.3508 8.13393L9.3977 11.0863C9.17804 11.3059 8.82196 11.3059 8.6023 11.0863L5.64918 8.13393C5.42948 7.91429 5.42943 7.55813 5.64908 7.33843C5.86872 7.11874 6.22487 7.11869 6.44457 7.33833L8.4375 9.33074V2.81348C8.4375 2.50282 8.68934 2.25098 9 2.25098ZM3.375 10.6885C3.375 10.3778 3.12316 10.126 2.8125 10.126C2.50184 10.126 2.25 10.3778 2.25 10.6885V14.626C2.25 14.9243 2.36853 15.2105 2.5795 15.4215C2.79048 15.6325 3.07663 15.751 3.375 15.751H14.625C14.9234 15.751 15.2095 15.6325 15.4205 15.4215C15.6315 15.2105 15.75 14.9243 15.75 14.626V10.6885C15.75 10.3778 15.4982 10.126 15.1875 10.126C14.8768 10.126 14.625 10.3778 14.625 10.6885V14.626H3.375V10.6885Z",
  fill: "#FBFAFF"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }